var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 190.698,
    height: 190.698,
    viewBox: "0 0 190.698 190.698",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(95.349 48.083) rotate(45)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-34 -34)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.1,4.479c0-.018,0-.036.008-.053a5.387,5.387,0,0,1,.283-.954C.4,3.449.4,3.426.413,3.4a5.507,5.507,0,0,1,.471-.894C.9,2.49.905,2.471.917,2.454A5.534,5.534,0,0,1,2.453.917C2.472.9,2.492.894,2.511.882A5.539,5.539,0,0,1,3.4.413l.07-.026A5.456,5.456,0,0,1,4.427.1C4.444.1,4.462.1,4.48.1A5.464,5.464,0,0,1,5.49,0H92.032a5.49,5.49,0,1,1,0,10.98H18.743l77.17,77.17a5.489,5.489,0,1,1-7.763,7.763L10.98,18.742V92.031a5.49,5.49,0,0,1-10.98,0V5.489a5.469,5.469,0,0,1,.1-1.01",
    transform: "translate(18.661 18.662)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrowUp.d4141cae3cade7d50226fde6ad8af31b.svg";
export { ForwardRef as ReactComponent };